'use client';

import classNames from 'classnames';
import Link from 'next/link';

import { SubmitButton } from '@/components/FormElements';
import { PageSection } from '@/components/PageSection';
import { Typography } from '@/components/Typography';
import { Wrapper } from '@/components/Wrapper';
import { useNewsletterSubscribeForm } from '@/providers';

export function NewsletterSubscribeSectionSmall() {
  const {
    formState,
    formMessage,
    showContactLink,
    responseSentiment,
    inputProps,
    contactPath,
  } = useNewsletterSubscribeForm();

  return (
    <PageSection
      padTop={false}
      padBottom={false}
      additionalClasses="bg-blue-100 py-4"
    >
      <Wrapper>
        <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-10">
          <div className="flex flex-col gap-half grow">
            <h4 className="text-heading-350">
              Subscribe to the 1440 Daily Digest
            </h4>
            <p className="text-body-350">
              The most impactful stories of the day, expertly curated and
              explained. <i>100% Free, unsubscribe anytime.</i>
            </p>
          </div>
          <div className="md:basis-[35rem] lg:basis-[44rem] shrink-0 flex flex-col gap-3">
            <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
              <input
                className="min-h-button-lg rounded-full px-5 py-2 bg-paper grow border border-blue-200"
                {...inputProps}
              />
              <SubmitButton
                loading={formState === 'loading'}
                variant="solid"
                color="blue"
                size="lg"
                className="relative sm:min-w-[16rem]"
              >
                Subscribe
              </SubmitButton>
            </div>
          </div>
        </div>

        {formMessage && (
          <div
            className={classNames('mt-4 border rounded-2 px-4 py-3', {
              'bg-red-100 border-red-300': responseSentiment === 'failure',
            })}
          >
            <Typography
              name="body-350"
              tag="p"
              className={classNames({
                'text-red-700': responseSentiment === 'failure',
              })}
            >
              {formMessage}
              {showContactLink && (
                <Link href={contactPath} className="block mt-1 text-link">
                  Contact us if you need help
                </Link>
              )}
            </Typography>
          </div>
        )}
      </Wrapper>
    </PageSection>
  );
}
